<template>
  <div style="padding: 16px">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <!-- <el-button :icon="Plus" type="primary" @click="handleEdit($event)">
          添加
        </el-button> -->
        <el-button type="primary" @click="syncGuest">批量同步嘉宾信息</el-button>
        <el-button type="primary" @click="exportGuest">导出全量嘉宾</el-button>
        <el-button type="primary" @click="exportRelateGuest">导出关联嘉宾</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="嘉宾名称">
            <el-input v-model="queryForm.name" clearable placeholder="请输入嘉宾名称" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryForm.status" placeholder="请选择状态">
              <el-option label="显示" :value="true" />
              <el-option label="隐藏" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="头像" prop="avatar">
        <template #default="{ row }">
          <el-image
            fit="cover"
            :src="
              row.avatar
                ? row.avatar
                : 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/meet-avatar-default.png'
            "
            style="width: 100px; height: 100px"
          />
        </template>
      </el-table-column>
      <el-table-column label="嘉宾名称" prop="name" show-overflow-tooltip />
      <el-table-column label="机构名称" prop="company" />
      <el-table-column label="职位" prop="position" />
      <template v-if="isJBH">
        <el-table-column label="嘉宾类型(提交)">
          <template #default="{ row: { type, tag, remark } }">
            {{ guestTypeString(type, tag, remark) }}
          </template>
        </el-table-column>
        <el-table-column label="嘉宾类型(复核)">
          <template #default="{ row: { myType, myTag, myRemark } }">
            {{ guestTypeString(myType, myTag, myRemark) }}
          </template>
        </el-table-column>
      </template>
      <el-table-column label="嘉宾介绍" prop="introduction" show-overflow-tooltip />
      <el-table-column label="参与论坛" prop="meetingNames" />
      <el-table-column label="论坛议程" prop="meetingScheduleNames" />
      <el-table-column label="创建时间" prop="createTime" />
      <el-table-column label="状态" prop="signNum" width="200">
        <template #default="{ row }">
          <el-switch
            v-model="row.status"
            active-text="显示"
            class="ml-2"
            inactive-text="隐藏"
            style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ccc"
            @change="changeStatus($event, row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" :width="240">
        <template #default="{ row }">
          <el-row>
            <el-link type="primary" :underline="false" @click="handleTranslate(row)">重新翻译</el-link>
            <el-link type="primary" :underline="false" @click="handleEdit(row)">编辑</el-link>
            <el-link
              v-if="isJBH && reviewGuestTypeUID.includes(userUID)"
              type="primary"
              :underline="false"
              @click="editGuestType(row)"
            >
              嘉宾类型复核
            </el-link>
          </el-row>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <GuestEdit ref="editRef" @fetch-data="fetchData" />

    <GuestTypeEditor ref="editGuestTypeRef" :data-source="guestTypeList" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import axios from 'axios'
  import { defineComponent, defineAsyncComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { _exportUserInfo } from '@/api/channel'

  import {
    syncGuests,
    queryGuestList,
    translationGuest,
    updateGuestStatus,
    exportGuestInfo,
    exportRelateGuestInfo,
  } from '@/api/exhibitionManage'
  import GuestTypeEditor from './components/GuestTypeEditor.vue'
  import GuestEdit from './components/guestEdit.vue'
  import { useRoute } from 'vue-router'

  export default defineComponent({
    name: 'ChannelManager',
    components: {
      GuestEdit,
      GuestTypeEditor,
    },
    setup() {
      const route = useRoute()

      const { meetingCode = '' } = route.query
      const { proxy } = getCurrentInstance()

      const state = reactive({
        queryForm: {
          name: '',
          pageNum: 1,
          pageSize: 10,
          language: 'CN',
          status: '',
          meetingCode,
        },
        type: '',
        total: 0,
        shopList: [],
        listLoading: false,
        list: [],
        userUID: '',
        guestTypeList: [],
        guestTypeMap: {},
        reviewGuestTypeUID: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        upLoadRef: null,
        resultRef: null,
        editGuestTypeRef: null,
        generateWxRef: null,
        exportRegisterRef: null,
        channelDetailRef: null,
        typeOptions: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '申请会议',
            value: 'HOLD_MEETING',
          },
          {
            label: '申请展览',
            value: 'EXHIBITION',
          },
        ],
        hostFlag: 'HOST',
        isJBH: (JSON.parse(localStorage.getItem('customInfo')) || {})?.tenantKey === 'J80A84ZBBA40PW1',
      })

      const handleEdit = (row) => {
        if (row.code) {
          state.editRef.showEdit(row)
        } else {
          state['editRef'].showEdit()
        }
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await delCoupon(row.id)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await queryGuestList(state.queryForm)
        state.list = (data && data.list) || []
        state.total = (data && data.total) || 0
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        queryData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        queryData()
      }

      onMounted(() => {
        queryData()
        getGuestTypeOptions()
        getReviewGuestTypePhone()
        try {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          state.userUID = userInfo.uid || userInfo.weMeetUid
        } catch (error) {}
      })

      function getReviewGuestTypePhone() {
        axios
          .get(`https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/JBH/2025/setting.json?t=${Date.now()}`)
          .then((res) => {
            state.reviewGuestTypeUID = res.data.review_guest_type_uid
          })
      }

      function getGuestTypeOptions() {
        axios
          .get(`https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/JBH/JSON/chooseGuest.json?t=${Date.now()}`)
          .then((res) => {
            state.guestTypeList = res.data.chooseGuestList
            state.guestTypeList.forEach((item, index) => {
              if (!index) {
                state.guestTypeMap[item.type] = item.title
              } else {
                item.list?.forEach((subItem) => {
                  state.guestTypeMap[subItem.code] = `${item.title} - ${subItem.name}`
                })
              }
            })
          })
      }

      const syncGuest = async () => {
        const { data } = await syncGuests({ meetingCode })
        queryData()
      }

      const handleTranslate = async (row) => {
        const { data } = await translationGuest(row.code, meetingCode)
        queryData()
      }

      const changeStatus = async (status, row) => {
        console.log(status, row)
        await updateGuestStatus(row.code, status, meetingCode)
        queryData()
      }

      const exportGuest = async () => {
        const { data } = await exportGuestInfo({ meetingCode })
        window.open(data.url)
      }

      const exportRelateGuest = async () => {
        const { data } = await exportRelateGuestInfo({ meetingCode })
        window.open(data.url)
      }

      function guestTypeString(type, tag, remark) {
        if (!tag) {
          return state.guestTypeMap[type] || '-'
        } else {
          let str = state.guestTypeMap[tag] || '-'
          if (remark) str = str.replace('其他', remark)
          return str
        }
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        Delete,
        Search,
        Plus,
        syncGuest,
        handleTranslate,
        changeStatus,
        exportGuest,
        exportRelateGuest,
        guestTypeString,
        editGuestType: (row) => state.editGuestTypeRef.open(row),
      }
    },
  })
</script>
<style lang="scss" scoped></style>
